import * as Business                   from '../business';
import { compose }                     from 'redux';
import { connect }                     from 'react-redux';
import { Fragment }                    from 'react';
import { getGoogleLocationIsVerified } from './google/display_helpers';
import FetchFromServer                 from '../components/fetch_from_server';
import Navbar                          from '../components/navbar';
import NotificationBadge               from '../components/notification_badge';
import React                           from 'react';


export default connect(
  (state, { businessID }) => ({
    statuses:                   Business.getBusinessStatuses(state, businessID),
    business:                   Business.getBusiness(state, businessID),
    googleLocationBadgeCount:   Business.getGoogleLocationBadgeCount(state, businessID),
    facebookLocationBadgeCount: Business.getFacebookLocationBadgeCount(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    load: compose(dispatch, Business.loadBusiness, () => (businessID))
  })
)(BusinessProfilePage);


function BusinessProfilePage({
  business,
  load,
  statuses,
  googleLocationBadgeCount,
  facebookLocationBadgeCount
}) {
  const { readStatus } = statuses;
  const isReady        = readStatus.succeeded;

  return (
    <Fragment>
      <Navbar title="Online Profiles"/>
      <FetchFromServer statuses={statuses} load={load} className="settings business-profile">
        {isReady && <OnlineProfiles {...{ business, googleLocationBadgeCount, facebookLocationBadgeCount }}/>}
      </FetchFromServer>
    </Fragment>
  );
}


function OnlineProfiles({ business, googleLocationBadgeCount, facebookLocationBadgeCount }) {
  const { name }              = business;
  const hasGoogleFeature      = business.features.profiles.google;
  const hasFacebookFeature    = business.features.profiles.facebook;
  const hasNextDoorFeature    = business.features.profiles.nextdoor;
  const hasTripAdvisorFeature = business.features.profiles.tripAdvisor;
  const hasYelpFeature        = business.features.profiles.yelp;

  return (
    <div className="list media-list block inset online-profiles">
      {name && <h4>{name}</h4>}
      <div className="list-group">
        <ul>
          {hasGoogleFeature && <GoogleOnlineProfile {...{ business, googleLocationBadgeCount }}/>}
          {hasFacebookFeature && <FacebookOnlineProfile {...{ business, facebookLocationBadgeCount }}/>}
          {hasNextDoorFeature && <NextdoorOnlineProfile {...{ business }}/>}
          {hasTripAdvisorFeature && <TripAdvisorOnlineProfile {...{ business }}/>}
          {hasYelpFeature && <YelpOnlineProfile {...{ business }}/>}
        </ul>
      </div>
    </div>
  );
}


function GoogleOnlineProfile({ business, googleLocationBadgeCount }) {
  return (
    <li>
      <a href={`/${business.id}/settings/business_profile/google`} className="item-content item-inner item-link">
        <div className="item-title-row">
          <div className="item-title">
            Google
          </div>
          <NotificationBadge className="badge-count" color="red" count={googleLocationBadgeCount}/>
          <div className="item-after"></div>
        </div>
        <div className="item-subtitle">
          {getGoogleStatus(business)}
        </div>
      </a>
    </li>
  );
}


export function getGoogleStatus({ google }) {
  const hasPlace       = google.cid;
  const hasLocation    = (google.id && google.location);
  const isDisconnected = (hasLocation && google.status === 403);
  const isVerified     = (hasLocation && getGoogleLocationIsVerified(google.location));

  if (hasPlace)
    return 'Connected';
  else if (hasLocation && isDisconnected)
    return 'Disconnected';
  else if (hasLocation && isVerified)
    return 'Connected';
  else if (hasLocation && !isVerified)
    return 'Connected, needs verification';
  else
    return 'Not connected';
}


function FacebookOnlineProfile({ business, facebookLocationBadgeCount }) {
  return (
    <li>
      <a href={`/${business.id}/settings/business_profile/facebook`} className="item-content item-inner item-link">
        <div className="item-title-row">
          <div className="item-title">
            Facebook
          </div>
          <NotificationBadge className="badge-count" color="red" count={facebookLocationBadgeCount}/>
          <div className="item-after"></div>
        </div>
        <div className="item-subtitle">
          {getFacebookStatus(business)}
        </div>
      </a>
    </li>
  );
}


export function getFacebookStatus({ facebook }) {
  const hasPageID   = facebook?.pageID;
  const isConnected = facebook?.status === 200;

  if (hasPageID && isConnected)
    return 'Connected';
  else if (hasPageID && !isConnected)
    return 'Connected, update needed';
  else
    return 'Not connected';
}


function YelpOnlineProfile({ business }) {
  return (
    <li>
      <a href={`/${business.id}/settings/business_profile/yelp`} className="item-content item-inner item-link">
        <div className="item-title-row">
          <div className="item-title">
            Yelp
          </div>
        </div>
        <div className="item-subtitle">
          {getYelpStatus(business)}
        </div>
      </a>
    </li>
  );
}


export function getYelpStatus({ yelp }) {
  if (yelp && yelp.id)
    return 'Connected';
  else
    return 'Not connected';
}


function NextdoorOnlineProfile({ business }) {
  return (
    <li>
      <a href={`/${business.id}/settings/business_profile/nextdoor`} className="item-content item-inner item-link">
        <div className="item-title-row">
          <div className="item-title">
            Nextdoor
          </div>
        </div>
        <div className="item-subtitle">
          {getNextdoorStatus(business)}
        </div>
      </a>
    </li>
  );
}


export function getNextdoorStatus({ nextdoor }) {
  if (nextdoor && nextdoor.id)
    return 'Connected';
  else
    return 'Not connected';
}


function TripAdvisorOnlineProfile({ business }) {
  return (
    <li>
      <a href={`/${business.id}/settings/business_profile/tripadvisor`} className="item-content item-inner item-link">
        <div className="item-title-row">
          <div className="item-title">
            TripAdvisor
          </div>
        </div>
        <div className="item-subtitle">
          {getTripAdvisorStatus(business)}
        </div>
      </a>
    </li>
  );
}


export function getTripAdvisorStatus({ tripAdvisor }) {
  if (tripAdvisor && tripAdvisor.id)
    return 'Connected';
  else
    return 'Not connected';
}
